import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDefect, PmsDefect } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDefect>
    useData={usePmsDefect}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
